import { parsePathString } from '../parser/parse-path-string';
export function path2Array(pathInput) {
    return parsePathString(pathInput);
}
//# sourceMappingURL=path-2-array.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/@antv/util/esm/path/convert/path-2-array.js
// module id = null
// module chunks = 